module.exports = __webpack_public_path__ + "static/media/check.f62ceb1b.png";